module.exports = "/assets/f09d5cca65cf35f2c4402c921c90a7a1.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/QU.png
// module id = 1764
// module chunks = 0